import React, { FC, useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import Link from 'next/link';
import Image from 'next/image';
import { processDate } from 'utils/helper';

interface IPost {
  author_id: number;
  content: string;
  date: string;
  id: number;
  image: string;
  lang: string;
  seo_description: string;
  status: number;
  title: string;
  slug: string;
  updated_at: string;
  url: string;
  likes: number;
  views: number;
  tagName: string;
}

interface IPostProps {
  post: IPost;
  tag?: any;
}
const PostItem: FC<IPostProps> = ({ post }): React.ReactElement => {
  const [{ user, likes }] = useCookies(['user', 'likes']);
  const [like, setLike] = useState<boolean>(false);

  useEffect(() => {
    try {
      likes[post.id] && setLike(true);
    } catch (err) {}
  });

  return (
    <li className="post-item">
      {/*{user?.isAdmin ? (*/}
      {/*  <a className="btn-edit btn-edit--card" title={`Edit post ${post.id}`} href={`/admin/article/${post.id}/edit`}>*/}
      {/*    <img src="/images/global/edit-btn.svg" alt="Edit Post" />*/}
      {/*  </a>*/}
      {/*) : (*/}
      {/*  <></>*/}
      {/*)}*/}

      <div className="post-item__image">
        {post.image && <Image src={post?.image} alt={post.title} width={337} height={200} />}
        <div className="shape">
          <svg viewBox="0 0 2880 480" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2160 0C1440 240 720 240 720 240H0v240h2880V0h-720z"
              fill="currentColor"
            />
          </svg>
        </div>
      </div>

      <div className="post-item__info">
        <Link className="post-item__info-link" href={`/blog/` + post.url}>
          <div className="post-item__info-title">
            {post.title?.length > 60 ? post.title.substr(0, 60) + '...' : post.title}
          </div>
        </Link>
      </div>

      <div className="post-item__footer">
        <div className="post-item__subject">
          <span className="post-item__subject-tag">{post.tagName ?? ''}</span>
          <span className="post-item__subject-date">{processDate(post.date)}</span>
        </div>

        <div className="post-item__statistics">
          {post.views > 0 ? (
            <div className="post-item__statistics-item">
              <svg
                className="post-item__statistics-icon"
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="eye"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path d="M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z" />
              </svg>
              <span>{post.views}</span>
            </div>
          ) : (
            <></>
          )}

          {post.likes > 0 ? (
            <div className="post-item__statistics-item">
              <svg
                className={`post-item__statistics-icon icon-likes${like ? ' isLike' : undefined}`}
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="heart"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z" />
              </svg>
              <span>{post.likes}</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </li>
  );
};

export default PostItem;
